'use client';

import React from 'react';
import styled from 'styled-components';
import { MonoValue } from '../MonoValue/MonoValue';

export interface KPICellProps {
  label: string;
  value: string | number;
  sub?: string;
  danger?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Label = styled.div`
  font-family: ${(p) => p.theme.fontFamily.ui};
  font-size: ${(p) => p.theme.fontSize.xs};
  font-weight: ${(p) => p.theme.fontWeight.semibold};
  color: ${(p) => p.theme.colors.neutral.inkMute};
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

// Extends MonoValue so the mono font-family comes from one place.
// Overrides size, weight, and color to hero-scale KPI display.
const HeroValue = styled(MonoValue)<{ $danger?: boolean }>`
  font-size: ${(p) => p.theme.fontSize.hero};
  font-weight: ${(p) => p.theme.fontWeight.extrabold};
  color: ${(p) => (p.$danger ? p.theme.colors.semantic.error.color : p.theme.colors.neutral.ink)};
  line-height: 1.1;
`;

const Sub = styled.div`
  font-family: ${(p) => p.theme.fontFamily.ui};
  font-size: ${(p) => p.theme.fontSize.xs};
  color: ${(p) => p.theme.colors.neutral.inkSoft};
`;

export function KPICell({ label, value, sub, danger, children, className }: KPICellProps) {
  return (
    <Wrapper aria-label={`${label}: ${value}`} className={className}>
      <Label>{label}</Label>
      <HeroValue value={value} $danger={danger} />
      {sub && <Sub>{sub}</Sub>}
      {children}
    </Wrapper>
  );
}
